// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LayerInputProperties } from "./LayerInputProperties";
import {
  LayerInputPropertiesFromJSON,
  LayerInputPropertiesFromJSONTyped,
  LayerInputPropertiesToJSON,
  LayerInputPropertiesToJSONTyped,
} from "./LayerInputProperties";

/**
 *
 * @export
 * @interface LayerOutput
 */
export interface LayerOutput {
  /**
   *
   */
  type?: LayerOutputTypeEnum;
  /**
   *
   */
  name: string;
  /**
   * Layer ID as defined in the file descriptor, or None for data types with only a single layer. NB: layer IDs are verified at creation time. If a file is later reprocessed, its descriptor layer IDs may change. Existing versions retain their original values and will still load, but API clients may encounter stale layer references.
   */
  layerInFile?: string | null;
  /**
   *
   */
  filePath: string;
  /**
   *
   */
  visible?: boolean;
  /**
   *
   */
  opacity?: number;
  /**
   *
   */
  properties?: LayerInputProperties | null;
  /**
   * Deprecated. Use properties.style_id instead.
   */
  readonly styleId: string | null;
  /**
   * Deprecated. Use properties.min_max instead.
   */
  readonly minMax: Array<any> | null;
}

/**
 * @export
 */
export const LayerOutputTypeEnum = {
  Layer: "layer",
} as const;
export type LayerOutputTypeEnum = (typeof LayerOutputTypeEnum)[keyof typeof LayerOutputTypeEnum];

/**
 * Check if a given object implements the LayerOutput interface.
 */
export function instanceOfLayerOutput(value: object): value is LayerOutput {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    (!("filePath" in (value as Record<string, any>)) &&
      !("file_path" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["filePath"] === undefined &&
      (value as Record<string, any>)["file_path"] === undefined)
  )
    return false;
  if (
    (!("styleId" in (value as Record<string, any>)) &&
      !("style_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["styleId"] === undefined &&
      (value as Record<string, any>)["style_id"] === undefined)
  )
    return false;
  if (
    (!("minMax" in (value as Record<string, any>)) &&
      !("min_max" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["minMax"] === undefined &&
      (value as Record<string, any>)["min_max"] === undefined)
  )
    return false;
  return true;
}

export function LayerOutputFromJSON(json: any): LayerOutput {
  return LayerOutputFromJSONTyped(json, false);
}

export function LayerOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayerOutput {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    name: json["name"],
    layerInFile:
      json["layer_in_file"] === undefined
        ? undefined
        : json["layer_in_file"] === null
        ? null
        : json["layer_in_file"],
    filePath: json["file_path"],
    visible: json["visible"] == null ? undefined : json["visible"],
    opacity: json["opacity"] == null ? undefined : json["opacity"],
    properties:
      json["properties"] === undefined
        ? undefined
        : json["properties"] === null
        ? null
        : LayerInputPropertiesFromJSON(json["properties"]),
    styleId: json["style_id"],
    minMax: json["min_max"] == null ? null : json["min_max"],
  };
}

export function LayerOutputToJSON(json: any): LayerOutput {
  return LayerOutputToJSONTyped(json, false);
}

export function LayerOutputToJSONTyped(
  value?: Omit<LayerOutput, "styleId" | "minMax"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    name: value["name"],
    layer_in_file: value["layerInFile"],
    file_path: value["filePath"],
    visible: value["visible"],
    opacity: value["opacity"],
    properties: LayerInputPropertiesToJSON(value["properties"]),
  };
}
